const staffActions = [
  {
    label: "Открыть",
    onClick: (id) => {
      window.location.href = `/staff/${id}`; // Переход на страницу профиля
    },
    color: "",
    tooltip: "Открыть профиль сотрудника",
  },
  {
    label: "Редактировать",
    onClick: (id) => {
      window.location.href = `/staff/edit/${id}`; // Переход на страницу редактирования
    },
    color: "",
    tooltip: "Редактировать данные сотрудника",
  },
  {
    label: "Удалить",
    onClick: (id, handlers) => handlers.onDelete(id),
    color: "red",
    tooltip: "Полностью удалить актив",
  },
];

export default staffActions; // Экспортируем массив
